// extracted by mini-css-extract-plugin
export default {"btn":"Btn_btn__SoHZL","btnSuccess":"Btn_btnSuccess__BDXvF"};